import React from 'react';
import { Grid } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import AccordionWrapper from '@/components/accordion/AccordionWrapper';
import DatasetCatalogueLeft from './DatasetCatalogueLeft';
import DatasetCatalogueMiddle from './DatasetCatalogueMiddle';
import DatasetCatalogueRight from './DatasetCatalogueRight';
import Selectors from '../hooks/selectors';
import Fetch from '../templates/hooks/fetch';

export const catalogueSectionAccordions = [
  { section: 'first', panel: 'left', Component: DatasetCatalogueLeft },
  { section: 'second', panel: 'middle', Component: DatasetCatalogueMiddle },
  { section: 'third', panel: 'right', Component: DatasetCatalogueRight },
];

const DatasetCatalogue = ({ category, code, url }) => {
  const intl = useIntl();
  const {
    readStatus, sections, templateCode, templateReadStatus, panels,
  } = Selectors.useDatasetCatalogue({ category, code });
  Fetch.useFetchCatalogueTemplateForDataset({
    category, code: templateCode, datasetCode: code, templateReadStatus, intl,
  }, readStatus);
  const components = catalogueSectionAccordions.filter(({ section }) => sections?.[section]);

  return (
    <Grid.Row columns="equal">
      {components.map(({ section, panel, Component }, index) => (
        <Grid.Column key={`dataset_catalogue_grid_column_${code}_${section}`}>
          <AccordionWrapper fluid styled open={panels[panel].includes(index)}>
            <Component category={category} code={code} url={url} />
          </AccordionWrapper>
        </Grid.Column>
      ))}
    </Grid.Row>
  );
};

export default DatasetCatalogue;
